import React, { useState, useEffect } from "react";
import { auth, db } from "../firebase/config";
import { collection, getDocs, doc, getDoc } from "firebase/firestore";

export default function CaptureDisplay() {
  const [recordings, setRecordings] = useState([]);
  const [loading, setLoading] = useState(true);
  const [companyId, setCompanyId] = useState(null);

  useEffect(() => {
    const fetchCompanyId = async () => {
      try {
        const user = auth.currentUser;
        if (!user) throw new Error("User not authenticated.");

        const companiesRef = collection(db, "companies");
        const companiesSnapshot = await getDocs(companiesRef);
        let foundCompanyId = null;

        for (const companyDoc of companiesSnapshot.docs) {
          if (companyDoc.data().ownerId === user.uid) {
            foundCompanyId = companyDoc.id;
            break;
          }
        }

        if (!foundCompanyId) throw new Error("Company ID not found.");
        setCompanyId(foundCompanyId);
      } catch (err) {
        console.error("Error fetching company ID:", err.message);
      }
    };

    const unsubscribe = auth.onAuthStateChanged((user) => {
      if (user) fetchCompanyId();
    });

    return () => unsubscribe();
  }, []);

  useEffect(() => {
    if (!companyId) return;

    const fetchRecordings = async () => {
      try {
        setLoading(true);
        const recordingsRef = collection(
          db,
          `companies/${companyId}/screen_recordings`
        );
        const recordingsSnapshot = await getDocs(recordingsRef);

        let recordingsData = await Promise.all(
          recordingsSnapshot.docs.map(async (docSnapshot) => {
            const data = docSnapshot.data();
            const employeeRef = doc(
              db,
              `companies/${companyId}/employees`,
              data.userId
            );
            const employeeDoc = await getDoc(employeeRef);
            const employeeName = employeeDoc.exists()
              ? employeeDoc.data().name
              : "Unknown Employee";

            return {
              id: docSnapshot.id,
              videoUrl: data.videoUrl,
              employeeName: employeeName,
            };
          })
        );

        setRecordings(recordingsData);
      } catch (err) {
        console.error("Error fetching recordings:", err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchRecordings();
  }, [companyId]);

  return (
    <div style={{ textAlign: "center", marginTop: "20px" }}>
      <h2>Employee Screen Recordings</h2>
      {loading && <p>Loading recordings...</p>}

      {recordings.length === 0 && !loading ? (
        <p>No recordings available.</p>
      ) : (
        <div>
          {recordings.map((recording) => (
            <div key={recording.id} style={{ marginBottom: "20px" }}>
              <h3>{recording.employeeName}</h3>
              <video
                src={recording.videoUrl}
                controls
                style={{ width: "80%", border: "1px solid black" }}
              />
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
